export default __webpack_public_path__ + "static/media/image37.ace7991e.png";